<template>
  <div>
    <v-card class="pb-3 mx-auto addLocationBg" rounded="xxl" style="text-align-last: center;" >
      <v-img
          class="white--text align-end"
          height="100px"
          src="~@/assets/beach-1110498_640.jpg"
          position="top center"
      >
        <v-card-title class="pb-0">Add a Piece of Your Journey</v-card-title>
        <v-card-subtitle class="mt-0 pb-1">Past, Current and Planned</v-card-subtitle>
      </v-img>


      <v-card-text class="mt-3 date-picker-container pb-0">
      <gmap-autocomplete class="placeAutoComplete" :key="autocompleteKey" @place_changed="initMarker" placeholder="Choose Location" :types="['(regions)']"></gmap-autocomplete>
      <v-menu ref="menu" v-model="arrivalDateManu" :close-on-content-click="false" :return-value.sync="stayDates" transition="scale-transition" offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-text-field v-model="dateRangeText" readonly v-bind="attrs" v-on="on" label="Dates / Arrival Date" class="centered-label mt-3 " style="max-width: 45vw"></v-text-field>
        </template>
        <v-date-picker v-model="stayDates" no-title scrollable range>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="arrivalDateManu = false">Cancel</v-btn>
          <v-btn text color="primary" @click="$refs.menu.save(stayDates)">OK</v-btn>
        </v-date-picker>
      </v-menu>

      </v-card-text>
      <v-card-actions>
        <v-btn style="text-transform: capitalize" rounded color="primary" class="ml-3" small @click="closeAddLocationDialog">Cancel</v-btn>
        <v-spacer></v-spacer>
        <v-btn style="text-transform: capitalize" rounded color="primary" class="mr-3" small @click="addStay">Done</v-btn>
      </v-card-actions>
    </v-card>
<!--    <v-list-item style="max-height: 4vh">-->
<!--      <v-icon>mdi-map-marker</v-icon>-->
<!--      <v-spacer></v-spacer>-->
<!--      <gmap-autocomplete :key="autocompleteKey" @place_changed="initMarker" placeholder="Choose Location" :types="['(regions)']"></gmap-autocomplete>-->
<!--      <v-spacer></v-spacer>-->
<!--      <v-tooltip bottom>-->
<!--        <template v-slot:activator="{ on, attrs }">-->
<!--          <div v-bind="attrs" v-on="on">-->
<!--            <v-checkbox style="margin-right: 12px" v-model="isPublicStay" on-icon="mdi-eye" off-icon="mdi-eye-off"></v-checkbox>-->
<!--          </div>-->
<!--        </template>-->
<!--        <span>Community Members Can See Where You Are</span>-->
<!--      </v-tooltip>-->
<!--    </v-list-item>-->
<!--    <v-list-item style="max-height: 4vh">-->
<!--      <v-icon>mdi-calendar</v-icon>-->
<!--      <v-spacer></v-spacer>-->
<!--      <v-menu ref="menu" v-model="arrivalDateManu" :close-on-content-click="false" :return-value.sync="stayDates" transition="scale-transition" offset-y min-width="auto" >-->
<!--        <template v-slot:activator="{ on, attrs }">-->
<!--          <v-text-field v-model="dateRangeText" readonly v-bind="attrs" v-on="on" label="Dates / Arrival Date" class="centered-label" style="max-width: 45vw"></v-text-field>-->
<!--        </template>-->
<!--        <v-date-picker v-model="stayDates" no-title scrollable range>-->
<!--          <v-spacer></v-spacer>-->
<!--          <v-btn text color="primary" @click="arrivalDateManu = false">Cancel</v-btn>-->
<!--          <v-btn text color="primary" @click="$refs.menu.save(stayDates)">OK</v-btn>-->
<!--        </v-date-picker>-->
<!--      </v-menu>-->
<!--      <v-spacer></v-spacer>-->
<!--      <v-btn small @click="addStay">Add</v-btn>-->
<!--    </v-list-item>-->
    <v-alert transition="scroll-y-transition" dismissible v-model="missingDataAlert" type="error" dense origin="top" border="right" style="position: fixed; top: 5vh">
      Location or Arrival date are Missing
    </v-alert>
  </div>
</template>

<script>
import {allMixins} from "@/mixins/allMixins";
import {store} from "@/store";

export default {
  name: "AddLocation",
  mixins: [allMixins],
  data() {
    return {
      autocompleteKey: 0,
      stayDates: [],
      arrivalDateManu: false,
      isPublicStay: store.state.userData.privacyDefault,
      existingPlace: null,
      locationAddedDialogVisible: false,
      addedLocationName: null,
      missingDataAlert: false,
    }
  },
  computed: {
    dateRangeText () {
      if (this.stayDates.length === 0) {
        return ''
      } else if (this.stayDates.length === 1) {
        return this.formattedDate()
      } else {
        return this.formattedDateRange()
      }
    },

  },

  methods: {
    formattedDate() {
      let dateString = this.stayDates[0] + 'T12:00:00'
      let date = new Date(dateString);
      date.setDate(date.getDate());
      const options = { year: "numeric", month: "short", day: "numeric" };
      return date.toLocaleDateString(undefined, options);
    },
    formattedDateRange() {
      let arrivalDateString = this.stayDates[0] + 'T12:00:00'
      let departureDateString = this.stayDates[1] + 'T12:00:00'
      let arrivalDate = new Date(arrivalDateString);
      arrivalDate.setDate(arrivalDate.getDate());
      let departureDate = new Date(departureDateString);
      departureDate.setDate(departureDate.getDate());

      const arrivalDay = arrivalDate.getDate();
      const departureDay = departureDate.getDate();
      const arrivalMonth = arrivalDate.toLocaleString('default', { month: 'short' }); // e.g., May
      const arrivalYear = arrivalDate.getFullYear();

      if (arrivalMonth === departureDate.toLocaleString('default', { month: 'short' }) && arrivalYear === departureDate.getFullYear()) {
        return `${arrivalDay} - ${departureDay} ${arrivalMonth}, ${arrivalYear}`
      } else if (arrivalYear === departureDate.getFullYear()) {
        let departureMonth = departureDate.toLocaleString('default', { month: 'short' });
        return `${arrivalMonth} ${arrivalDay} - ${departureMonth} ${departureDay}, ${arrivalYear}`
      } else {
        let departureMonth = departureDate.toLocaleString('default', { month: 'short' });
        return `${arrivalMonth} ${arrivalDay}, ${arrivalYear} - ${departureMonth} ${departureDay}, ${departureDate.getFullYear()}`
      }
    },
    closeAddLocationDialog() {
      this.$emit('closeAddLocationDialog');
    },
    initMarker(loc) {
      this.existingPlace = loc;
    },
    async addStay() {
      if (!this.stayDates || !this.existingPlace) {
        this.missingDataAlert = true
        return
      }
      this.$emit('closeAddLocationDialog');
      this.missingDataAlert = false
      store.commit("loadingOn")
      let addLocationSuccess = await this.addLocationMarker()
      if (addLocationSuccess) {
        await store.dispatch("getTopLocations")
        await store.dispatch("getMyLocations")
        await store.dispatch("getUserData")
        store.commit('handleAddedLocationDialog', this.existingPlace.name || this.existingPlace?.formatted_address)
        this.existingPlace = null;
      }
      store.commit("loadingOff")
    },
  }
}
</script>

<style>
.addLocationBg{
  background-color: #A9C9FF;
  background-image: linear-gradient(180deg, #A9C9FF 0%, #FFBBEC 100%);
}
.placeAutoComplete{
  background-color: #d9e4f6;
  border-radius: 15px;
}
.date-picker-container {
  display: flex;
  justify-content: center; /* Aligns vertically center */
  align-items: center; /* Aligns horizontally center */
  flex-direction: column; /* Stack children vertically */
}

</style>
